(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.osanoMenuLink = {
    attach: (context) => {
      $(once('osanoMenuLink', 'a[href="#osano-cm"]')).each(function () {
        $(this).click(function (e){
          e.preventDefault();
          window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
        });
      });
    }
  };

})(jQuery, Drupal);
